




















import { Vue, Component, Prop } from 'vue-property-decorator'
import { alert } from "@/utils/notification"
import { getKey } from "@/utils/key"
import { uploadFile } from "@/apis/enroll/files"
import type { HttpRequestOptions } from 'element-ui/types/upload'

@Component
export default class PhotoUploader extends Vue {
  @Prop({ required: true }) value!: string
  @Prop({ default: false }) print!: boolean

  @Prop() upload!: typeof uploadFile
  @Prop({ default: "照片" }) placeholder!: string
  @Prop({ default: 1024 * 1024 * 5 }) maxFileSize!: number

  getKey = getKey

  get isFullPath() {
    return this.value.startsWith("http://")
      || this.value.startsWith("http://")
      || this.value.includes("$") // legacy issue
  }

  get src() {
    return this.isFullPath
      ? this.value
      : `${process.env.VUE_APP_BASE_API}/student/Files/${this.value}`
  }

  async handlePhotoUpload(options: HttpRequestOptions) {
    const { file, onProgress } = options

    if (file.size > this.maxFileSize) {
        alert("上传失败", new Error("照片不能大于 5M"))
        return false;
    }

    const onUploadProgress = (e: any) => {
      onProgress({
        ...e,
        percent: Math.round((e.loaded * 100) / e.total)
      })
    }

    try {
      const upload = this.upload || uploadFile
      const photo = await upload(file, onUploadProgress)
      const path = photo.replaceAll("\\","$").replaceAll("/","$");
      this.$emit("update:value", path)
      alert("上传成功")
    } catch(e) {
      alert("上传失败", e)
    }
  }
}
